var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18024",
    "data-name": "Group 18024",
    transform: "translate(-263 -720)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 29,
    height: 29,
    rx: 14.5,
    transform: "translate(263 720)",
    fill: "#f2921b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.557,19h0l-1.49-.41L5.675,15.9c-.436-.119-.825-.231-1.188-.34l-.611,2.706-1.49-.41L3,15.117l-.038-.01-.273-.079L2.6,15c-.219-.063-.44-.126-.662-.188L0,14.28.74,12.4c.008,0,1.019.3,1.081.3A.751.751,0,0,0,2,12.719a.559.559,0,0,0,.507-.417l.976-4.316L3.544,8l.1.027a1.154,1.154,0,0,0-.155-.055L4.18,4.894a.869.869,0,0,0-.694-.958c-.006-.019-.682-.2-1.082-.3L2.8,1.88l2.056.567,0,.009c.264.072.566.151.952.246L6.417,0l1.49.41-.6,2.65.009,0,.013,0c.359.09.775.2,1.172.3L9.1.737l1.49.41-.61,2.7c2.271.865,3.221,2.069,2.989,3.786a2.564,2.564,0,0,1-1.9,2.417c1.522.875,1.957,2.144,1.37,3.992a3.138,3.138,0,0,1-3.309,2.459,9.624,9.624,0,0,1-1.949-.237L6.557,19ZM5.789,9.951l-.818,3.624.265.076.021.006a9.427,9.427,0,0,0,2.467.465c1.036,0,1.653-.407,1.834-1.21C9.992,11,7.4,10.354,6.158,10.045c-.137-.034-.265-.066-.369-.094ZM6.907,5.005h0L6.165,8.292l.122.035.113.033.012,0a7.34,7.34,0,0,0,1.984.374,1.45,1.45,0,0,0,1.626-1.129c.395-1.746-1.768-2.272-2.807-2.525C7.1,5.055,6.992,5.029,6.907,5.005Z",
    transform: "translate(270 725)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.04ff57b9567383e2c01ff98578c8e0f8.svg";
export { ForwardRef as ReactComponent };